import { toast as sonnerToast } from "sonner";

type ToastMessage = string;

export const toast = {
  success: (message: ToastMessage, opts?: { description?: string }) =>
    sonnerToast.success(message, opts),
  error: (message: ToastMessage, opts?: { description?: string }) =>
    sonnerToast.error(message, opts),
  info: (message: ToastMessage, opts?: { description?: string }) =>
    sonnerToast.info(message, opts),
  warning: (message: ToastMessage, opts?: { description?: string }) =>
    sonnerToast.warning(message, opts),
  loading: (message: ToastMessage) => sonnerToast.loading(message),
  dismiss: (id?: string | number) => sonnerToast.dismiss(id),
  promise: <T,>(
    p: Promise<T>,
    msgs: { loading: string; success: string | ((data: T) => string); error: string | ((err: unknown) => string) }
  ) => sonnerToast.promise(p, msgs),
};
